<button
    ds-button
    msThemedButton
    kind="secondary"
    variant="filled"
    size="large"
    [themeKind]="buttonThemeKind"
    [themeVariant]="buttonThemeVariant"
    [disabled]="false"
    (click)="submitRemoveAutoCashout()">
    {{ btnText }}
</button>

@if (removeError) {
    <div class="error">
        <div class="error-message">
            <vn-icon class="autocashout-error-icon" name="theme-error-i" size="16" />
            <span>{{ removeError }}</span>
        </div>
    </div>
}
